<div class="mt-10 legenda-wrapper">
	<div
		class="bg-white rounded shadow-lg d-flex flex-column card legenda-card"
		id="legenda"
		*ngIf="valores && valores.length > 0">
		<div class="card-body">
			<label for="legenda" class="text-muted fw-semibold legenda-titulo">
				{{ mapaNome + (valores[0].unidade ? ' (' + valores[0].unidade + ')' : '') }}
			</label>
			<div class="legenda-scroll">
				<div class="legenda-horizontal legenda-faixa">
				<div
					*ngIf="temInfoAdicional; else cores"
					class="d-flex justify-content-start w-100 mt-1"
					id="icon-with-labels-container">
					<div class="expanded" *ngFor="let valor of valores; index as i">
						<seira-icon-with-label>
							<i
								icon
								[style.color]="valor.cor"
								[ngClass]="'shadow-item'"
								class="ph ph-circle-fill me-2"></i>
							<label label class="text-tertiary">{{
								valor.infoAdicional
							}}</label>
						</seira-icon-with-label>
					</div>
				</div>
				<ng-template #cores>
					<div
						*ngFor="let valor of valores; index as i"
						class="legenda-item shadow"
						[style]="borderRadius(i)"
						[style.backgroundColor]="valor.cor"></div>
				</ng-template>
			</div>
			</div>

			<div *ngIf="!temInfoAdicional">
				<div class="legenda-scroll">
					<div class="legenda-horizontal legenda-valores">
					<div
						*ngFor="let valor of valores; index as i"
						[class]="'legenda-item ' + (i === 0 ? 'legenda-centro' : '')"
						[ngClass]="temInfoAdicional ? 'ms-2' : ''">
						<div *ngIf="i === 0 && valor.unidade === '%'">
							{{ valor.valorMin | formatDecimal: 1 }}
						</div>
						<div *ngIf="i === 0 && valor.unidade !== '%'">
							≤ {{ valor.valorMax | formatDecimal: 1 }}
						</div>
						<div *ngIf="i > 0 && i < valores.length - 1">
							{{ valor.valorMin | formatDecimal: 1 }}
						</div>
						<div *ngIf="i === valores.length - 1">
							≥ {{ valor.valorMin | formatDecimal: 1 }}
						</div>
					</div>
				</div>
				</div>
			</div>
		</div>
	</div>
</div>
